/* Cura naturale : halo adaptatif des bannières (point 60 de cn-socle.css, spec-halo-adaptatif.md).
   Pour chaque bannière à texte, lit la photo affichée sous chaque ligne de texte et pose sur le bloc de texte
   la densité de halo (--cn-halo) la plus faible qui rend chaque texte au moins aussi lisible que sur la
   bannière Histoire de l'accueil (référence validée par Aurélie), entre 0 et 0,60. La forme du halo ne change
   pas (taille, flou, haut plus doux). Sans ce script, ou si la photo ne peut pas être lue : 0,41. */
(() => {
  const PLAFOND = 0.6;
  const PLANCHER = 0;
  // Contraste médian du texte le moins lisible de la référence, mesuré à 1 440 px (ordinateur) et à 390 px
  // (mobile) : titres (« grand ») ; sur-titres et textes (« petit »). Voir outils-tests/halo-simu.py.
  const CIBLES = { ordinateur: { grand: 6.9, petit: 5.4 }, mobile: { grand: 7.6, petit: 5.7 } };
  const MOBILE = window.matchMedia('(max-width: 860px)');
  const HAUT = 0.16 / 0.41; // haut du halo rapporté à son palier, comme le dégradé du point 60
  const ANTHRACITE = [43, 42, 39];
  const ECHELLE = 1; // la photo est lue à sa taille affichée : réduite, un motif fin (Calendrier) se lisait 5 à 7 % trop sombre
  const BLOCS = '[id^="cn-hero-"] .cn-inner, [id^="cn-manifesto-"] .cn-inner, [id^="cn-av-"] .cn-av-hero__inner, .image-overlay > .text-overlay--for-banner .text-overlay__text';

  const LINEAIRE = Array.from({ length: 256 }, (_, i) => { const v = i / 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
  const lum = (r, g, b) => 0.2126 * LINEAIRE[Math.round(r)] + 0.7152 * LINEAIRE[Math.round(g)] + 0.0722 * LINEAIRE[Math.round(b)];
  const erf = x => { // Abramowitz et Stegun 7.1.26
    const s = x < 0 ? -1 : 1, a = Math.abs(x), t = 1 / (1 + 0.3275911 * a);
    return s * (1 - ((((1.061405429 * t - 1.453152027) * t + 1.421413741) * t - 0.284496736) * t + 0.254829592) * t * Math.exp(-a * a));
  };
  const phi = z => 0.5 * (1 + erf(z / Math.SQRT2));

  const photoDe = bloc => {
    const cadre = bloc.closest('.cn-slide, [id^="cn-manifesto-"], .cn-av-hero, .image-overlay');
    return cadre ? [...cadre.querySelectorAll('img')].find(i => !bloc.contains(i)) || null : null;
  };

  // Lignes de chaque texte (hors boutons), sa couleur, son opacité (les opacités sous 0,8 sont des animations
  // d'apparition : ignorées) et sa taille (grand : 24 px, ou 18,66 px en 700).
  const textesDe = bloc => {
    const items = [];
    bloc.querySelectorAll('*').forEach(el => {
      if (el.closest('.cn-cta, .cn-av-btn, .btn, button')) return;
      const s = getComputedStyle(el);
      if (!/^(transparent|rgba\(0, 0, 0, 0\))$/.test(s.backgroundColor)) return;
      const lignes = [];
      el.childNodes.forEach(n => {
        if (n.nodeType !== 3 || !n.textContent.trim()) return;
        const r = document.createRange(); r.selectNodeContents(n);
        for (const q of r.getClientRects()) if (q.width > 1 && q.height > 1) lignes.push(q);
      });
      if (!lignes.length) return;
      const c = (s.color.match(/[\d.]+/g) || []).map(Number);
      if (c.length < 3) return;
      let op = 1;
      for (let e = el; e && e !== bloc.parentElement; e = e.parentElement) { const o = parseFloat(getComputedStyle(e).opacity); if (o >= 0.8) op *= o; }
      const fs = parseFloat(s.fontSize), fw = parseInt(s.fontWeight, 10);
      items.push({ lignes, couleur: c.slice(0, 3), alpha: (c.length > 3 ? c[3] : 1) * op, grand: fs >= 24 || (fs >= 18.66 && fw >= 700) });
    });
    return items;
  };

  // Halo du bloc tel que le navigateur le dessine : rectangle à dégradé vertical, flou gaussien.
  const haloDe = bloc => {
    const s = getComputedStyle(bloc, '::before');
    if (s.content === 'none') return null;
    const q = bloc.getBoundingClientRect();
    const positions = (s.backgroundImage.match(/(\d+(?:\.\d+)?)px/g) || []).map(parseFloat);
    const rampe = Math.max(0, ...positions) || (MOBILE.matches ? 115 : 131);
    return { x0: q.left + parseFloat(s.left), y0: q.top + parseFloat(s.top), l: parseFloat(s.width), h: parseFloat(s.height),
      flou: parseFloat((s.filter.match(/blur\(([\d.]+)px\)/) || [])[1]) || 72, rampe };
  };
  const profil = h => {
    const s = h.flou, norme = 2 / (s * Math.sqrt(2 * Math.PI)), cache = new Map();
    const vy = y => {
      const k = Math.round(y);
      if (!cache.has(k)) {
        let t = 0;
        for (let v = 1; v < h.h; v += 2) { const d = k - h.y0 - v; t += (HAUT + (1 - HAUT) * Math.min(v / h.rampe, 1)) * Math.exp(-d * d / (2 * s * s)); }
        cache.set(k, t * norme);
      }
      return cache.get(k);
    };
    return (x, y) => (phi((x - h.x0) / s) - phi((x - h.x0 - h.l) / s)) * vy(y);
  };

  const regler = async (bloc, essai = 0) => {
    try {
      const img = photoDe(bloc);
      if (!img || !img.complete || !img.naturalWidth) return;
      // Un SVG (avec sa photo intégrée) n'est pas toujours prêt pour le canvas quand il s'affiche : on attend
      // son décodage avant de le dessiner (sans cela, une fois sur quatre la zone lue reste vide).
      await img.decode().catch(() => {});
      const h = haloDe(bloc);
      if (!h) return;
      const items = textesDe(bloc), ib = img.getBoundingClientRect();
      if (!items.length || ib.width < 10 || ib.height < 10) return;
      let x1 = Infinity, y1 = Infinity, x2 = -Infinity, y2 = -Infinity;
      items.forEach(it => it.lignes.forEach(r => { x1 = Math.min(x1, r.left); y1 = Math.min(y1, r.top); x2 = Math.max(x2, r.right); y2 = Math.max(y2, r.bottom); }));
      x1 = Math.max(x1, ib.left); y1 = Math.max(y1, ib.top); x2 = Math.min(x2, ib.right); y2 = Math.min(y2, ib.bottom);
      if (x2 - x1 < 2 || y2 - y1 < 2) return;
      const cle = [img.currentSrc, innerWidth, Math.round(ib.top - y1), Math.round(ib.left - x1), Math.round(x2 - x1), Math.round(y2 - y1)].join('|');
      if (bloc.dataset.cnHaloCle === cle && bloc.style.getPropertyValue('--cn-halo')) return; // rien n'a changé
      // Cadrage de la photo dans son cadre (object-fit et object-position)
      const st = getComputedStyle(img), nw = img.naturalWidth, nh = img.naturalHeight;
      const pos = st.objectPosition.split(' ').map(p => (p.endsWith('%') ? parseFloat(p) / 100 : 0.5));
      let kx, ky, ox = 0, oy = 0;
      if (st.objectFit === 'cover') { kx = ky = Math.max(ib.width / nw, ib.height / nh); ox = (ib.width - nw * kx) * pos[0]; oy = (ib.height - nh * ky) * (pos[1] ?? 0.5); }
      else if (st.objectFit === 'fill') { kx = ib.width / nw; ky = ib.height / nh; }
      else return;
      // Photo entière dessinée à sa taille affichée, puis seule la zone des textes est gardée : naturalWidth est
      // corrigé selon la version téléchargée (srcset), il ne peut pas servir à découper le fichier lui-même.
      const cw = Math.max(1, Math.round((x2 - x1) * ECHELLE)), ch = Math.max(1, Math.round((y2 - y1) * ECHELLE));
      const c = document.createElement('canvas'); c.width = cw; c.height = ch;
      const g = c.getContext('2d', { willReadFrequently: true });
      g.drawImage(img, (ib.left + ox - x1) * ECHELLE, (ib.top + oy - y1) * ECHELLE, nw * kx * ECHELLE, nh * ky * ECHELLE);
      const px = g.getImageData(0, 0, cw, ch).data;
      // Zone vide ou presque (photo pas encore prête) : rien n'est décidé, une zone vide se lirait comme du
      // noir et retirerait le halo à tort. Nouvel essai un peu plus tard, puis halo de la référence.
      let pleins = 0;
      for (let i = 3; i < px.length; i += 4) if (px[i] >= 250) pleins++;
      if (pleins < px.length / 8) {
        if (essai < 4) setTimeout(() => regler(bloc, essai + 1), 400);
        return;
      }
      const forme = profil(h), cible = CIBLES[MOBILE.matches ? 'mobile' : 'ordinateur'];
      let besoin = PLANCHER;
      for (const it of items) {
        const R = [], G = [], B = [], F = [];
        const surface = it.lignes.reduce((t, r) => t + Math.max(0, Math.min(r.right, x2) - Math.max(r.left, x1)) * Math.max(0, Math.min(r.bottom, y2) - Math.max(r.top, y1)), 0);
        const pas = Math.max(1 / ECHELLE, Math.sqrt(surface / 3000)); // au plus 3 000 points par texte
        for (const r of it.lignes) {
          for (let y = Math.max(r.top, y1) + pas / 2; y < Math.min(r.bottom, y2); y += pas) {
            for (let x = Math.max(r.left, x1) + pas / 2; x < Math.min(r.right, x2); x += pas) {
              const i = (Math.min(ch - 1, Math.floor((y - y1) * ECHELLE)) * cw + Math.min(cw - 1, Math.floor((x - x1) * ECHELLE))) * 4;
              if (px[i + 3] < 250) continue; // pixel transparent : pas de photo derrière ce point
              R.push(px[i]); G.push(px[i + 1]); B.push(px[i + 2]); F.push(forme(x, y));
            }
          }
        }
        if (R.length < 8) continue;
        const [tr, tg, tb] = it.couleur, A = it.alpha, seuil = it.grand ? cible.grand : cible.petit;
        const median = d => {
          const t = new Float32Array(R.length);
          for (let j = 0; j < R.length; j++) {
            const a = d * F[j];
            const cr = (1 - a) * R[j] + a * ANTHRACITE[0], cg = (1 - a) * G[j] + a * ANTHRACITE[1], cb = (1 - a) * B[j] + a * ANTHRACITE[2];
            t[j] = (lum(A * tr + (1 - A) * cr, A * tg + (1 - A) * cg, A * tb + (1 - A) * cb) + 0.05) / (lum(cr, cg, cb) + 0.05);
          }
          t.sort();
          return t[t.length >> 1];
        };
        let u;
        if (median(0) >= seuil) u = 0;
        else if (median(PLAFOND) < seuil) u = PLAFOND;
        else { let bas = 0, haut = PLAFOND; for (let n = 0; n < 10; n++) { const m = (bas + haut) / 2; if (median(m) < seuil) bas = m; else haut = m; } u = haut; }
        besoin = Math.max(besoin, u);
      }
      bloc.style.setProperty('--cn-halo', Math.min(PLAFOND, Math.max(PLANCHER, besoin)).toFixed(3));
      bloc.dataset.cnHaloCle = cle;
    } catch (e) {
      bloc.style.removeProperty('--cn-halo'); // photo illisible : halo de la référence
    }
  };

  const suivies = new WeakSet();
  const toutRegler = () => document.querySelectorAll(BLOCS).forEach(bloc => {
    const img = photoDe(bloc);
    if (!img) return;
    if (!suivies.has(img)) { suivies.add(img); img.addEventListener('load', () => regler(bloc)); }
    if (img.complete && img.naturalWidth) regler(bloc);
  });
  let minuterie;
  window.addEventListener('resize', () => { clearTimeout(minuterie); minuterie = setTimeout(toutRegler, 250); });
  document.addEventListener('shopify:section:load', toutRegler);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(toutRegler);
  toutRegler();
})();
